import type { FullCar } from '../../types/Car'
import { computed } from 'vue'

export function useCarAdditionalInfo(dataAddition?: FullCar['dataAddition']) {
  const additionalInfo = computed(() => {
    return dataAddition || []
  })

  const sortedAdditionalInfo = computed(() => {
    return additionalInfo.value
      ?.slice()
      .sort(
        (a, b) =>
          new Date(a.additionTime).getTime()
            - new Date(b.additionTime).getTime(),
      )
  })

  return { additionalInfo, sortedAdditionalInfo }
}
